import styled, { css, createGlobalStyle } from 'styled-components';

export const FadeAnimCSS = createGlobalStyle`
  .fade-enter, .fade-exit {
    transition: all 1s;
  }
  .fade-enter-active, .fade-exit-active {
    transition: all 1s;
  }
  .fade-enter, .fade-exit-active {
    opacity: 0;
  }
  .fade-exit, .fade-enter-active {
    opacity: 1;
  }
`;
export const CollapsibleAnimCSS = createGlobalStyle`
  .collapsible-enter, .collapsible-exit {
    transition: max-height 1s ease-out;
    overflow: hidden;
  }
  .collapsible-enter-active, .collapsible-exit-active {
    transition: max-height 1s ease-in;
  }
  .collapsible-enter, .collapsible-exit-active {
    max-height: 0;
  }
  .collapsible-exit, .collapsible-enter-active {
    max-height: 1000px;
  }

`;
export const ToolTipCSS = createGlobalStyle`
  .tooltip {
    display: none;
    position:absolute;
    text-align:left;

    &.dot {
      right: 0;
    }
    @media (min-width: 600px) {
      display: inline-block;
    }
  }
  .tooltip .fa {
    font-size: 15px;
    vertical-align: middle;
    margin-left: 5px;
  }
  .tooltip .top {
    top:-10px;
    left:50%;
    transform:translate(-50%, -100%);
    padding:10px 12px;
    background-color:#002a4e;
    border-radius:8px;
    position:absolute;
    z-index:99999999;
    box-sizing:border-box;
    box-shadow:0 1px 8px rgba(0,0,0,0.5);
    visibility:hidden; opacity:0; transition:opacity 0.8s;

    &.event0 {
      background-color: #ff0000;
    }
    &.event1 {
      background-color: #21693E;
    }
    &.event2 {
      background-color: #5597E8;
    }
    &.event3 {
      background-color: #5dcdce;
    }
    &.event4 {
      background-color: #c455e8;
    }
    &.event5 {
      background-color: #7b61ff;
    }
  }
  .tooltip .text {
    font-weight:normal;
    font-size:14px;
    color:#ffffff;
    font-family: "Montserrat",sans-serif;
    text-transform: none;
    white-space: normal;
    max-width: 200px;
    line-height: 1.2em;
    letter-spacing: 0;

    &.long {
      white-space: normal;
      width: 200px;
    }
    &.medium {
      white-space: normal;
      min-width: 100px;
      max-width: 200px;
    }
    &.nowrap {
      white-space: nowrap;
    }
    a {
      color: #fff;
      text-decoration: underline;
    }
  }
  .tooltip:hover .top {
    visibility:visible; opacity:1;
  }
  .tooltip .top i {
    position:absolute;
    top:100%;
    left:50%;
    margin-left: -12px;
    width:24px;
    height:12px;
    overflow:hidden;
    font-size: 12px;
  }
  .tooltip .top {
    i::after {
      content:'';
      position:absolute;
      width:12px;
      height:12px;
      left:50%;
      transform:translate(-50%,-50%) rotate(45deg);
      background-color:#002a4e;
      box-shadow:0 1px 8px rgba(0,0,0,0.5);
    }
    &.event0 i::after {
      background-color: #ff0000;
    }
    &.event1 i::after {
      background-color: #21693E;
    }
    &.event2 i::after {
      background-color: #5597E8;
    }
    &.event3 i::after {
      background-color: #5dcdce;
    }
    &.event4 i::after {
      background-color: #c455e8;
    }
    &.event5 i::after {
      background-color: #7b61ff;
    }
  }
  &.dot .top i {
    margin-left: -23px;
  }
`;
export const DropdownCSS = createGlobalStyle`
  .closed {
    border: 1px solid #000;
  }
  .open {
    border: none;

    > div {
      border: 1px solid #000;
      border-bottom: none;
      border-top-color: #ccc;

      &:first-child {
        border-top-color: #000;
      }
      &:last-child {
        border-bottom: 1px solid #000;
      }
    }
  }
`;
export const CommonCSS = createGlobalStyle`
  .toggle.react-toggle {
    margin: 0 10px;
  }
  .toggle.react-toggle .react-toggle-track, .toggle.react-toggle--checked .react-toggle-track, .toggle.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: #002A4E;
  }
  .toggle.react-toggle .react-toggle-thumb, .giftToggle.react-toggle .react-toggle-thumb {
    border-color: #002A4E;
  }
  .toggle.react-toggle..react-toggle--disabled {
    opacity: 1;
  }
  .giftToggle.react-toggle .react-toggle-thumb {
    background-color: #777;
    border-color: #777;
  }
  .giftToggle.react-toggle--checked .react-toggle-thumb {
    background-color: #fff;
    border-color: #005789;
  }
  .giftToggle.react-toggle .react-toggle-track, .giftToggle.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: #ccc;
  }
  .giftToggle.react-toggle--checked .react-toggle-track, .giftToggle.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: #005789;
  }
  .react-datepicker-wrapper {
    display: block;
  }
  input[type=text] {
    width: 100%;
    color: #000;
    background: #f2f2f2;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-family: 'Montserrat',sans-serif;
    padding: 0 15px;
    height: 36px;

    &.error {
      outline: 1px solid DarkRed;
    }
  }
  input[type=checkbox] {
    transform: scale(1.5);
    margin: 6px 15px;
  }
  .counter {
    white-space: nowrap;
  }
  .ticketGroup {
    display: flex;
    justify-content: space-between;
    margin: 30px 20px 0 20px;
    flex-wrap: wrap;

    @media (min-width: 1240px) {
      max-width: 1200px;
      margin: 30px auto 0 auto;
      padding-bottom: 30px;
    }
  }
  iframe#barclay {
    height: 420px;
    @media (min-width: 576px) {
      height: 400px;
    }
  }
  @media (max-width: 767px) {
    .mobile-hide {
      display: none;
    }
  }
  .PhoneInputCountryIcon--border {
    box-shadow: none;
    svg {
      vertical-align: top;
    }
  }
  .valid {
    position: relative;
  }
  .valid .PhoneInput::before {
    position: absolute;
    right: 10px;
    content: '\f00c';
    color: green;
    font-family: "Font Awesome 5 Free";
    font-style: normal;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  .validMark {
    position: absolute;
    right: 60px;
    top: 33px;
  }
  .PhoneInputCountry {
    margin-right: 0;
    margin-left: 10px;
    order: 2;
  }
  .nowrap {
    white-space: nowrap;
  }
  .react-datepicker-wrapper {
    flex: 1;
  }
`;
